/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggest_Workout_LoadInputs */

const en_us2_coach_suggest_workout_load = /** @type {(inputs: Coach_Suggest_Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I add weight?`)
};

const pt_br2_coach_suggest_workout_load = /** @type {(inputs: Coach_Suggest_Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso subir a carga?`)
};

const es_419_coach_suggest_workout_load = /** @type {(inputs: Coach_Suggest_Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo subir el peso?`)
};

const pt_pt2_coach_suggest_workout_load = /** @type {(inputs: Coach_Suggest_Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso aumentar a carga?`)
};

const fr_fr2_coach_suggest_workout_load = /** @type {(inputs: Coach_Suggest_Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je peux augmenter la charge ?`)
};

const de_de2_coach_suggest_workout_load = /** @type {(inputs: Coach_Suggest_Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich mehr Gewicht nehmen?`)
};

const it_it2_coach_suggest_workout_load = /** @type {(inputs: Coach_Suggest_Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso aumentare il carico?`)
};

/**
* | output |
* | --- |
* | "Can I add weight?" |
*
* @param {Coach_Suggest_Workout_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggest_workout_load = /** @type {((inputs?: Coach_Suggest_Workout_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggest_Workout_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggest_workout_load(inputs)
	if (locale === "es-419") return es_419_coach_suggest_workout_load(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggest_workout_load(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggest_workout_load(inputs)
	if (locale === "de-DE") return de_de2_coach_suggest_workout_load(inputs)
	if (locale === "it-IT") return it_it2_coach_suggest_workout_load(inputs)
	return en_us2_coach_suggest_workout_load(inputs)
});
export { coach_suggest_workout_load as "coach.suggest_workout_load" }